<template>
    <div>
        <div class="layer-content">
            <div class="layer-txt-area">
                <!-- 사전 동의 하에 전문 상담원이<br>선생님의 PC를 함께 보면서 유선상으로 설명하기 힘드시거나<br>
                PC에 대해 잘 모르는 선생님을 위한 서비스 입니다.<br><br>
                먼저 보육인WorkS 고객지원팀 <span class="pc01">1644-3129</span>으로 전화하시면,<br>원격지원 이용방법을 자세히 안내해드리겠습니다. -->
                <ul>
                    <li class="__left">① 상담 대표번호 <span style="color: red">1644-3129</span>로 통화 연결 후, 상담원에게 원격지원을 요청하세요.<br></li>
                    <li class="__left mgt5">② 하단의 <span style="color: red">[원격지원 시작]</span> 버튼을 눌러주세요.<br></li>
                    <li class="__left mgt5">③ 상담원에게 안내 받은 <span style="color: red">번호</span>를 선택해주세요.<br></li>
                </ul>
            </div>
        </div>
        <div class="btn-wrap layer-btn">
            <div style="width: 50%"><button class="_bt-blue" @click="startRmtAstnc()" style="width: 100%"><span>원격지원 시작</span></button></div>
            <div style="width: 50%"><button @click="closePopup()" style="width: 100%"><span>취소</span></button></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "explnRmtAstnc_popup",
        methods : {
            startRmtAstnc : function(){
                var url = "http://113366.com/onandon";
                var name = "bo6inRemote";

                window.open(url, name);

                this.closePopup();

            },
            closePopup : function(){
                this.$store.getters.getComponents.popup.close('explnRmtAstncPopup');
            }
        }
    }
</script>

<style scoped>

</style>